// extracted by mini-css-extract-plugin
export var root = "bZzz";
export var rootContainer = "yBB0";
export var rootHeading = "Kon0";
export var rootItems = "UOMg";